const styles = (theme: any) => ({
  root: {
    paddingRight: theme.spacing(),
  },
  spacer: {
    // flex: '1 1 100%',
  },
  actions: {
    minWidth: 320,
    // flex: '0 0 auto',
    color: theme.palette.text.secondary,
  },
  title: {
    paddingTop: 18,
    flexGrow: 1,
    // flex: '0 0 auto',
  },
});

export default styles;
